export default "__VITE_ASSET__1313d7a5__"